<iframe class="responsive-iframe" id="fDrive" [src]="iframeUrl"></iframe>
